<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-10 col-md-12 offset-lg-2 main-body">
                <table class="table table-bordered table-responsive-md">
                    <thead class="thead-light">
                    <th>S/N</th>
                    <th>Name</th>
                    <th>Position</th>
                    <th>DateCreated</th>
                    <th>Actions</th>
                    </thead>
                    <tbody>
                    <template v-if="familyMembers.length > 0">
                        <tr v-for="(item,index) in familyMembers" :key="index">
                            <td>{{index+1}}</td>
                            <td>{{item.surname + ' ' + item.baptismalName}}</td>
                            <td>{{determineFamilyPosition(item)}}</td>
                            <td>{{parseFirestoreTime(item.dateCreated)}}</td>
                            <td v-if="parishionerData.baptismalName !== item.baptismalName">
                                <a href="#" style="display: inline-block;margin-right: 10px" @click.prevent="displayModal('edit_modal',index)"><i class="icon ion-md-create"></i></a>
                                <a href="#" style="display: inline-block" @click.prevent="displayModal('delete_modal',index)"><i class="icon ion-md-trash"></i></a>
                            </td>
                            <td v-else>
                                <i>Unavailable</i>
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr>
                            <td colspan="5">
                                <h6 class="text-center"><i>you have no family member yet</i></h6>
                            </td>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </div>
            <!-- Edit Modal-->
            <div class="col-12">
                <b-modal id="edit_modal" title="Edit Family Member" size="lg" hide-footer>
                    <form role="form" @submit.prevent="validate_form_fields" class="vld-parent" ref="editModal">
                        <div class="col-12 signup-container">
                            <div class="row">
                                <!-- Signup body -->
                                <div class="col-12 signup-body">
                                    <!-- first row -->
                                    <div class="row signup-body-1">
                                        <div class="col-lg-4 col-md-12 offset-lg-4 p-t-20">
                                            <div class="pic-frame" @click="toggle_passport_upload" :style='{"background-image":"url("+singleParishionerData.picture+")"}'>
                                                <div class="frame-overlay">
                                                    <span class="text text-white" style="display: block;background-color: rgba(50,50,50,.7);padding:5px;font-size: .7em"><i class="icon ion-md-hand text-white"></i> click to change passport</span>
                                                </div>
                                                <input type="file" class="frame-file" accept="image/*" id="stdenis-passport" @change="verify_profile_pic_upload">
                                            </div>
                                        </div>
                                        <div class="col-12 text-center" style="margin-top:20px" v-if="profile_pic">
                                            <button class="btn stdenis-btn" @click.prevent="updateProfilePicture">Apply changes</button>
                                        </div>

                                    </div>
                                    <!-- Second row -->
                                    <div class="row signup-body-2">
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="surname" class="text-left">Surname:</label>
                                            <input type="text" class="form-control" id="surname" placeholder="Surname" v-model="singleParishionerData.surname"  autofocus>
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="othername" class="text-left">Othername:</label>
                                            <input type="text" class="form-control" id="othername" placeholder="Other Name" v-model="singleParishionerData.otherName" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="baptismalname" class="text-left">Baptismal Name:</label>
                                            <input type="text" class="form-control" id="baptismalname" placeholder="Baptismal Name" v-model="singleParishionerData.baptismalName" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="sex" class="text-left">Sex:</label>
                                            <select class="form-control" v-model="singleParishionerData.sex" id="sex" >
                                                <option value="">Select an option</option>
                                                <option value="male">Male</option>
                                                <option value="female">Female</option>
                                            </select>
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="dob" class="text-left">Date of Birth:</label>
                                            <input type="date" class="form-control" id="dob" v-model="singleParishionerData.dateOfBirth" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="resident_addr" class="text-left">Residential Address:</label>
                                            <input type="text" class="form-control" id="resident_addr" placeholder="Address" v-model="singleParishionerData.residentialAddress" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="occupation" class="text-left">Occupation:</label>
                                            <input type="text" class="form-control" id="occupation" placeholder="Occupation" v-model="singleParishionerData.occupation" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="mobile_tel" class="text-left">Mobile Number:</label>
                                            <input type="tel" class="form-control" id="mobile_tel" placeholder="Mobile Number" v-model="singleParishionerData.phone" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="u_email" class="text-left">Email Address:</label>
                                            <input type="email" class="form-control" id="u_email" placeholder="Email Address" v-model="singleParishionerData.email" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="bcc_center" class="text-left">B.C.C Center:</label>
                                            <select class="form-control" v-model="singleParishionerData.BCC" id="bcc_center">
                                                <option value="">Select a BCC Center</option>
                                                <option v-for="centers in bcc_centerID.length" :value="bcc_centerID[centers-1]" :key="centers">
                                                    {{bcc_centerName[centers-1]}}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="u_joined" class="text-left">Year of Joining Church:</label>
                                            <input type="number" class="form-control" id="u_joined" placeholder="Year Joined" v-model="singleParishionerData.yearOfJoiningChurch" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <div class="row">
                                                <!--                                             Society Details-->
                                                <div class="col-12 gap text-left">
                                                    <label>Statutory Organization:</label>
                                                    <input type="text" class="form-control" :value="curr_society" disabled>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 gap">
                                            <div class="row">
                                                <div class="col-12 gap">
                                                    <h4>Societal Details</h4>
                                                </div>
                                                <div class="col-lg-12 col-md-12">
                                                    <div>
                                                        <span><p class="text-info">update the societies he/she belongs to:</p></span>
                                                    </div>
                                                    <template>
                                                        <v-select :options="societiesName" v-model="singleParishionerData.society" :reduce="society => society.id" label="society" multiple></v-select>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 gap">
                                            <div class="row">
                                                <!-- Sacramental Details-->
                                                <div class="col-12 gap">
                                                    <h4>Sacramental Details</h4>
                                                </div>
                                                <div class="col-12 gap">
                                                    <div class="row">
                                                        <div class="col-lg-6 col-md-12">
                                                            <h6 class="text-left">Are you Baptized?</h6>
                                                            <div class="col-12 text-left">
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[singleParishionerData.isBaptised?'active':'']" @click="toggle_inputs('baptism', 'yes')">
                                                                        <input class="form-check-input" type="radio" id="baptized_yes">
                                                                    </label>
                                                                    <label for="baptized_yes" class="text-left no-width form-check-label">Yes</label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[singleParishionerData.isBaptised?'':'active']" @click="toggle_inputs('baptism', 'no')">
                                                                        <input class="form-check-input" type="radio" id="baptized_no">
                                                                    </label>
                                                                    <label for="baptized_no" class="text-left no-width form-check-label" >No</label>
                                                                </div>
                                                            </div>
                                                            <transition name="custom-name" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                                                                <template v-if="singleParishionerData.isBaptised">
                                                                    <div>
                                                                        <h6 class="text-left">Date of Baptism</h6>
                                                                        <div class="text-left">
                                                                            <input type="date" class="form-control" v-model="singleParishionerData.dateOfBaptism">
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </transition>
                                                        </div>
                                                        <div class="col-lg-6 col-md-12">
                                                            <h6 class="text-left">Are you a Communicant?</h6>
                                                            <div class="col-12 text-left">
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[singleParishionerData.isCommunicant?'active':'']" @click="toggle_inputs('communicant', 'yes')">
                                                                        <input class="form-check-input" type="radio" id="communicant_yes">
                                                                    </label>
                                                                    <label for="communicant_yes" class="text-left no-width form-check-label">Yes</label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[singleParishionerData.isCommunicant?'':'active']" @click="toggle_inputs('communicant', 'no')">
                                                                        <input class="form-check-input" type="radio" id="communicant_no">
                                                                    </label>
                                                                    <label for="communicant_no" class="text-left no-width form-check-label" >No</label>
                                                                </div>
                                                            </div>
                                                            <transition name="custom-name" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                                                                <template v-if="singleParishionerData.isCommunicant">
                                                                    <div>
                                                                        <h6 class="text-left">Date of Communion</h6>
                                                                        <div class="text-left">
                                                                            <input type="date" class="form-control" v-model="singleParishionerData.dateOfFirstCommunion">
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </transition>
                                                        </div>
                                                        <div class="col-lg-6 col-md-12">
                                                            <h6 class="text-left">Are you Confirmed?</h6>
                                                            <div class="col-12 text-left">
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[singleParishionerData.isConfirmed?'active':'']" @click="toggle_inputs('confirmed', 'yes')">
                                                                        <input class="form-check-input" type="radio" id="confirmed_yes">
                                                                    </label>
                                                                    <label for="confirmed_yes" class="text-left no-width form-check-label">Yes</label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[singleParishionerData.isConfirmed?'':'active']" @click="toggle_inputs('confirmed', 'no')">
                                                                        <input class="form-check-input" type="radio" id="confirmed_no">
                                                                    </label>
                                                                    <label for="confirmed_no" class="text-left no-width form-check-label" >No</label>
                                                                </div>
                                                            </div>
                                                            <transition name="custom-name" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                                                                <template v-if="singleParishionerData.isConfirmed">
                                                                    <div>
                                                                        <h6 class="text-left">Date Confirmed</h6>
                                                                        <div class="text-left">
                                                                            <input type="date" class="form-control" v-model="singleParishionerData.dateOfConfirmation">
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </transition>
                                                        </div>
                                                        <div class="col-lg-6 col-md-12">
                                                            <h6 class="text-left">Are you Married in the church?</h6>
                                                            <div class="col-12 text-left">
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[singleParishionerData.isMarriedInChurch?'active':'']" @click="toggle_inputs('married', 'yes')">
                                                                        <input class="form-check-input" type="radio" id="married_yes">
                                                                    </label>
                                                                    <label for="married_yes" class="text-left no-width form-check-label">Yes</label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[singleParishionerData.isMarriedInChurch?'':'active']" @click="toggle_inputs('married', 'no')">
                                                                        <input class="form-check-input" type="radio" id="married_no">
                                                                    </label>
                                                                    <label for="married_no" class="text-left no-width form-check-label" >No</label>
                                                                </div>
                                                            </div>
                                                            <transition name="custom-name" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                                                                <template v-if="singleParishionerData.isMarriedInChurch">
                                                                    <div>
                                                                        <h6 class="text-left">Name of Parish</h6>
                                                                        <div class="text-left">
                                                                            <input type="text" class="form-control" v-model="singleParishionerData.nameOfParishWedded">
                                                                        </div>
                                                                        <h6 class="text-left">Date of Marriage</h6>
                                                                        <div class="text-left">
                                                                            <input type="date" class="form-control" v-model="singleParishionerData.dateOfMarriage">
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </transition>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <h6>Signature</h6>
                                            <div class="sig-container" :style='{"background-image":"url("+singleParishionerData.signature+")"}'>
                                                <label class="hint-text">
                                                <span style="display: block;background-color: rgba(50,50,50,.7)">
                                                <i class="icon ion-md-checkbox-outline text-white"></i><span class="inner-hint text-white"> update signature</span>
                                                <input type="file" id="signature" @change="read_sig_url">
                                                </span>
                                                </label>
                                            </div>
                                            <div class="col-12 text-left" style="margin-top:20px" v-if="signature_url">
                                                <button class="btn stdenis-btn" @click.prevent="updateSignature">Apply changes</button>
                                            </div>
                                        </div>

                                    </div>
                                    <!-- submit area-->
                                    <div class="row">
                                        <div class="col-lg-12 col-md-12 text-center">
                                            <button type="submit" class="btn stdenis-btn">Update</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </b-modal>
            </div>
            <!-- Delete Modal-->
            <div class="col-12">
                <b-modal id="delete_modal" centered title="Delete Family Member Data" hide-footer>
                    <div class="col-12 text-center" ref="deleteModal">
                        <button class="btn btn-lg btn-danger" @click.prevent="deleteMember">Confirm Delete <i class="icon ion-md-trash text-white"></i> </button>
                    </div>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css'

    import Swal from 'sweetalert2/dist/sweetalert2.js'
    import {firestoreDB, rawFirestore} from '../../config/firebase'
    import {firestoreTimeStamp} from "../../config/firebase";
    import {firestoreStorage} from "../../config/firebase";


    const parishioners = firestoreDB.collection("parishioners");
    // eslint-disable-next-line no-unused-vars
    const familiesRef = firestoreDB.collection("families");
    const parishionerStorageREF = firestoreStorage.ref();
    const societiesREF = firestoreDB.collection("societies");
    const zonesREF = firestoreDB.collection("zones");

    export default {
        name: "FamilyMember",
        data(){
            return {
                familyMembers:[],
                parishionerData:{
                    familyID:'',
                    sex:''
                },
                familyData:{
                    dateCreated:'',
                    members:[],
                    name:''
                },
                parishionerID: sessionStorage.getItem('dashboardID'),
                monthNames: [
                    "January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"
                ],
                singleParishionerData: {
                    zone: '',
                    baptismalName: '',
                    dateOfBaptism: '',
                    dateOfBirth: '',
                    dateOfConfirmation: '',
                    dateOfFirstCommunion: '',
                    dateOfMarriage: '',
                    dateUpdated: '',
                    email: '',
                    isBaptised: false,
                    isCommunicant: false,
                    isConfirmed: false,
                    isMarriedInChurch: false,
                    nameOfParishWedded: '',
                    occupation: '',
                    otherName: '',
                    phone: '',
                    pictureRef:"",
                    signatureRef:"",
                    residentialAddress: '',
                    sex: '',
                    statutoryOrganization: '',
                    society:[],
                    surname: '',
                    yearOfJoiningChurch: ''
                },
                singleParishionerID:'',

                profile_pic_url:'',
                profile_pic:'',
                profile_pic_name:'', profile_pic_ext:'',
                parishioners_doc_ref:'',
                form_number:'',
                reg_no: '',
                baptismal_date:'',
                bcc_centerID:[],bcc_centerName:[],
                organization_name:'',
                society_membership:false,societiesID:[],societiesName:[],
                society_names:[],
                society_ID:"",
                this_year(){
                    let now = new Date();
                    return now.getFullYear();
                },
                fullPage:false,
                signature_url:'',
                signature_ext:''
            }
        },
        computed: {
            curr_society: function(){
                return  this.determineOrganization(this.singleParishionerData.dateOfBirth);
            },
        },
        watch: {
            'singleParishionerData.isMarriedInChurch': function(newval){
                if(newval === true){
                    if(this.singleParishionerData.sex === this.parishionerData.sex){
                        this.display_alert("Hey","You can not select the same gender for the same married value","warning");
                        this.singleParishionerData.isMarriedInChurch = false
                    }
                }
            },
            'singleParishionerData.sex': function(newval){
                // eslint-disable-next-line no-undef
                $('#sex').val(newval);
                if(this.singleParishionerData.isMarriedInChurch === true){
                    if(newval === this.parishionerData.sex){
                        this.display_alert("Hey","You can not select the same gender for the same married value","warning");
                        this.singleParishionerData.isMarriedInChurch = false
                    }
                }
            },
            'singleParishionerData.BCC': function(newval){
                // eslint-disable-next-line no-undef
                $('#bcc_center').val(newval)
            }
        },
        methods: {
            loadFamilyData(){
                familiesRef.doc(this.parishionerData.familyID).get().then((doc)=>{
                    if(doc.exists){
                        this.familyData = doc.data();
                        this.loadFamilyMembers();
                    }
                })
            },
            loadParishionerData(){
                parishioners.doc(this.parishionerID).get().then((doc) => {
                    if(doc.exists){
                        this.parishionerData = doc.data();
                        this.loadFamilyData()
                    }
                })
            },
            loadFamilyMembers(){
                this.familyMembers.push(this.parishionerData);
                if(this.familyData.members.length > 0){
                    for(let count=0; count < this.familyData.members.length; count++){
                        parishioners.doc(this.familyData.members[count]).get().then((doc)=>{
                            this.familyMembers.push(doc.data());
                        })
                    }
                }
            },
            determineFamilyPosition(memberData){
                if(memberData){
                    if(memberData.isMarriedInChurch === true && memberData.sex === "male"){
                        return  "Father";
                    }else if(memberData.isMarriedInChurch === true && memberData.sex === "female"){
                        return "Mother";
                    }else{
                        return "Child";
                    }
                }
            },
            parseFirestoreTime(timestamp){
                try{
                    let tmp_time = timestamp.toDate();
                    if(tmp_time.getDate()){
                        return tmp_time.getDate() + " " + this.monthNames[tmp_time.getMonth()] + " " + tmp_time.getFullYear();
                    }
                }catch (e) {
                    return "None"
                }
                return "None"
            },
            displayModal(id, memberIndex){
                this.$bvModal.show(id);
                parishioners.doc(this.familyData.members[memberIndex]).get().then((doc)=>{
                    this.singleParishionerData = doc.data();
                    this.singleParishionerData.dateOfBirth = this.firestoreTimestamp_to_dateinput(this.singleParishionerData.dateOfBirth);
                    this.singleParishionerData.dateOfBaptism = this.firestoreTimestamp_to_dateinput(this.singleParishionerData.dateOfBaptism);
                    this.singleParishionerData.dateOfConfirmation = this.firestoreTimestamp_to_dateinput(this.singleParishionerData.dateOfConfirmation);
                    this.singleParishionerData.dateOfFirstCommunion = this.firestoreTimestamp_to_dateinput(this.singleParishionerData.dateOfFirstCommunion);
                    this.singleParishionerData.dateOfMarriage = this.firestoreTimestamp_to_dateinput(this.singleParishionerData.dateOfMarriage);

                    this.singleParishionerID = this.familyData.members[memberIndex];
                });
            },
            toggle_inputs: function(context, value){
                switch (context) {
                    // Society Based selections
                    case 'society_membership':
                        switch (value) {
                            case 'yes':
                                this.society_membership = true;
                                break;
                            case 'no':
                                this.society_membership = false;
                                break;
                        }
                        break;
                    case 'baptism':
                        switch (value) {
                            case 'yes':
                                this.singleParishionerData.isBaptised = true;
                                break;
                            case 'no':
                                this.singleParishionerData.isBaptised = false;
                                break;
                        }
                        break;
                    case 'communicant':
                        switch (value) {
                            case 'yes':
                                this.singleParishionerData.isCommunicant = true;
                                break;
                            case 'no':
                                this.singleParishionerData.isCommunicant = false;
                                break;
                        }
                        break;
                    case 'confirmed':
                        switch (value) {
                            case 'yes':
                                this.singleParishionerData.isConfirmed = true;
                                break;
                            case 'no':
                                this.singleParishionerData.isConfirmed = false;
                                break;
                        }
                        break;
                    case 'married':
                        this.singleParishionerData.nameOfParishWedded = "";
                        this.singleParishionerData.dateOfMarriage = "";
                        switch (value) {
                            case 'yes':
                                this.singleParishionerData.isMarriedInChurch = true;
                                break;
                            case 'no':
                                this.singleParishionerData.isMarriedInChurch = false;
                                break;
                        }
                        break;
                }

            },
            toggle_passport_upload: function(){
                // eslint-disable-next-line no-undef
                let passport_box = $('#stdenis-passport');
                passport_box.trigger('click');
            },
            verify_profile_pic_upload(){
                let passport = document.getElementById('stdenis-passport');
                let ext = passport.value.split('.').pop().toLowerCase();
                // eslint-disable-next-line no-undef
                if ($.inArray(ext, ['gif','png','jpg','jpeg']) === -1){
                    this.display_alert('Oops...', 'incorrect file type!', 'error');
                    passport.value = "";
                    this.profile_pic_url = "";
                    // eslint-disable-next-line no-undef
                    let upload_hint = $('.frame-overlay');
                    // eslint-disable-next-line no-undef
                    $('.pic-frame').css('background-image', '');
                    upload_hint.css('opacity', 1);
                }else{
                    // eslint-disable-next-line no-undef
                    let upload_hint = $('.frame-overlay');
                    upload_hint.css('opacity', 0);
                    this.read_file_url(passport);
                }
            },
            read_file_url(input){
                if (input.files && input.files[0]) {
                    let reader = new FileReader();
                    reader.onload = (e) => {
                        // eslint-disable-next-line no-undef
                        $('.pic-frame').css('background-image', 'url('+e.target.result+')');
                        this.profile_pic_url = e.target.result;
                        this.profile_pic = input.files[0];
                        // save image extension
                        this.profile_pic_ext = input.files[0].name.split('.').pop();
                    };
                    reader.readAsDataURL(input.files[0]);
                }
            },
            firestoreTimestamp_to_dateinput: function(firestoreDate){
                try{
                    let new_date = firestoreDate.toDate();
                    // let new_date = new Date();
                    let day = ("0" + new_date.getDate()).slice(-2);
                    let month = ("0" + (new_date.getMonth() + 1)).slice(-2);
                    return  new_date.getFullYear() + "-" + (month)+"-"+(day) ;
                }catch (e) {
                    return ""
                }
            },
            validate_form_fields(){
                // eslint-disable-next-line no-undef
                // if(this.profile_pic_url.length <= 0 && this.singleParishionerData.picture.length <= 0){
                //     this.display_alert('Oops...', 'Upload your passport', 'warning');
                //     return false
                // }
                if(this.singleParishionerData.surname.length <= 0){
                    this.display_alert('Oops...', 'fill in your surname', 'warning');
                    return false
                }
                if(this.singleParishionerData.otherName.length <= 0){
                    this.display_alert('Oops...', 'fill in your other name', 'warning');
                    return false
                }
                if(this.singleParishionerData.baptismalName.length <= 0){
                    this.display_alert('Oops...', 'fill in your baptismal name', 'warning');
                    return false
                }
                if(this.singleParishionerData.sex.length <= 0){
                    this.display_alert('Oops...', 'fill in your gender', 'warning');
                    return false
                }
                if(this.singleParishionerData.dateOfBirth.length <= 0){
                    this.display_alert('Oops...', 'fill in your date of birth', 'warning');
                    return false
                }
                if(this.singleParishionerData.residentialAddress.length <= 0){
                    this.display_alert('Oops...', 'fill in your residential address', 'warning');
                    return false
                }
                if(this.singleParishionerData.occupation.length <= 0){
                    this.display_alert('Oops...', 'fill in your occupation', 'warning');
                    return false
                }
                if(this.singleParishionerData.phone.length <= 6){
                    this.display_alert('Oops...', 'invalid mobile number', 'error');
                    return false
                }
                // if(this.email.length <= 0){
                //     this.display_alert('Oops...', 'fill in your email address', 'warning');
                //     return false
                // }
                // if(!this.is_email(this.email)){
                //     this.display_alert('Oops...', 'incorrect email format', 'error');
                //     return false
                // }
                if(this.singleParishionerData.BCC.length <= 0){
                    this.display_alert('Oops...', 'fill in your BCC Center', 'warning');
                    return false
                }
                if(this.singleParishionerData.yearOfJoiningChurch > this.this_year() || this.yr_joined_church <= 1 ){
                    this.display_alert('Oops...', 'fill in a valid year', 'warning');
                    return false
                }
                if(this.society_membership === true){
                    if(this.society_name.length <= 0){
                        this.display_alert('Oops...', 'fill in your society\'s name', 'warning');
                        return false
                    }
                }
                if(this.singleParishionerData.isBaptised === true){
                    if(this.singleParishionerData.dateOfBaptism.length <= 0){
                        this.display_alert('Oops...', 'fill in your baptismal date', 'warning');
                        return false
                    }
                }
                if(this.singleParishionerData.isConfirmed === true){
                    if(this.singleParishionerData.dateOfConfirmation.length <= 0){
                        this.display_alert('Oops...', 'fill in your confirmation date', 'warning');
                        return false
                    }
                }
                if(this.singleParishionerData.isCommunicant === true){
                    if(this.singleParishionerData.dateOfFirstCommunion.length <= 0){
                        this.display_alert('Oops...', 'fill in your communion date', 'warning');
                        return false
                    }
                }
                if(this.singleParishionerData.isMarriedInChurch === true){
                    if(this.singleParishionerData.dateOfMarriage.length <= 0 || this.singleParishionerData.nameOfParishWedded.length <= 0){
                        this.display_alert('Oops...', 'fill in the remaining marriage details', 'warning');
                        return false
                    }
                }
                // if(this.signature_url.length <= 0 && this.singleParishionerData.signature.length <= 0){
                //     this.display_alert('Oops...', 'Upload your signature', 'warning');
                //     return false
                // }
                this.submit_update_details();
            },
            display_alert: function(msg_head, message, error_type){
                Swal.fire({
                    title: msg_head,
                    showClass: {
                        popup: 'animated fadeInDown faster'
                    },
                    hideClass: {
                        popup: 'animated fadeOutUp faster'
                    },
                    text: message,
                    icon: error_type,
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 2000

                })
            },
            is_email(email){
                var regex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                return regex.test(email);
            },
            submit_update_details(){
                let loader = this.showLoadingOverlay("edit");
                // eslint-disable-next-line no-unused-vars
                let updateDetails = this.singleParishionerData;
                updateDetails.dateOfBaptism = this.formatDate(this.singleParishionerData.dateOfBaptism);
                updateDetails.dateOfBirth = this.formatDate(this.singleParishionerData.dateOfBirth);
                updateDetails.dateOfConfirmation = this.formatDate(this.singleParishionerData.dateOfConfirmation);
                updateDetails.dateOfFirstCommunion = this.formatDate(this.singleParishionerData.dateOfFirstCommunion);
                updateDetails.dateOfMarriage = this.formatDate(this.singleParishionerData.dateOfMarriage);
                updateDetails.dateUpdated = firestoreTimeStamp;

                // eslint-disable-next-line no-unused-vars
                parishioners.doc(this.singleParishionerID).update(updateDetails).then(() => {
                    loader.hide();
                    setTimeout(() => {
                        this.display_alert('success', 'Submitted', 'success');
                        setTimeout(()=>{
                            this.$router.go();
                        },2500);
                    }, 1000);
                }).catch((error) => {
                    loader.hide();
                    setTimeout(() => {
                        switch (error.code) {
                            case 'permission-denied':
                                this.display_alert('Error', "Permission Denied!", 'error');
                                break;
                            default:
                                this.display_alert('Error', error, 'error');
                                console.log(error);
                        }
                    }, 1000);

                });
            },
            updateProfilePicture(){
                let loader = this.showLoadingOverlay("edit");
                let filename = this.singleParishionerData.surname + this.singleParishionerData.othername;
                this.profile_pic_name = filename + '.'+ this.profile_pic_ext;
                const parishionersImageRef = parishionerStorageREF.child('parishioners_photo/2/'+ filename + '/' +this.profile_pic_name);
                parishionersImageRef.put(this.profile_pic).then(snapshot => {
                    return snapshot.ref.getDownloadURL()
                }).then(url => {
                    let ParishionerREF = parishioners.doc(this.singleParishionerID);
                    ParishionerREF.update({
                        picture: url,
                    }).then(()=>{
                        loader.hide();
                        setTimeout(() => {
                            this.display_alert('success', 'Submitted', 'success');
                            setTimeout(()=>{
                                this.$router.go();
                            },2500);
                        }, 1000);
                    })
                }).catch((error) => {
                    loader.hide();
                    setTimeout(() => {
                        switch (error.code) {
                            case 'permission-denied':
                                this.display_alert('Error', "Permission Denied!", 'error');
                                break;
                            default:
                                this.display_alert('Error', error, 'error');
                                console.log(error);
                        }
                    }, 1000);

                });
            },
            updateSignature(){
                let loader = this.showLoadingOverlay("edit");
                let filename = this.singleParishionerData.surname + this.singleParishionerData.othername + '_signature'+'.'+this.signature_ext;
                const parishionersSigRef = parishionerStorageREF.child('parishioners_signature/2/'+filename);
                parishionersSigRef.put(this.signature_url).then(snapshot => {
                    return snapshot.ref.getDownloadURL()
                }).then(url => {
                    let ParishionerREF = parishioners.doc(this.singleParishionerID);
                    ParishionerREF.update({
                        signature: url,
                    }).then(()=>{
                        loader.hide();
                        setTimeout(() => {
                            this.display_alert('success', 'Submitted', 'success');
                            setTimeout(()=>{
                                this.$router.go();
                            },2500);
                        }, 1000);
                    })
                }).catch((error) => {
                    loader.hide();
                    setTimeout(() => {
                        switch (error.code) {
                            case 'permission-denied':
                                this.display_alert('Error', "Permission Denied!", 'error');
                                break;
                            default:
                                this.display_alert('Error', error, 'error');
                                console.log(error);
                        }
                    }, 1000);

                });
            },
            showLoadingOverlay(modal){
                let modalREF = "";
                switch (modal) {
                    case 'edit':
                        modalREF = this.$refs.editModal;
                        break;
                    case 'delete':
                        modalREF = this.$refs.deleteModal;
                        break;
                }
                return this.$loading.show({
                    // Optional parameters
                    container: this.fullPage ? null : modalREF,
                    canCancel: false,
                });
            },
            formatDate(dateinputValue){
                if(dateinputValue.length > 0){
                    return new Date(dateinputValue);
                }
                return ""

            },
            fetchSocieties(){
                societiesREF.get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        // doc.data() is never undefined for query doc snapshots
                        let societyID = doc.id;
                        let societyName = doc.data().name;
                        this.societiesName.push({
                            society: societyName,
                            id: societyID
                        });
                        // console.log(JSON.stringify(societyObj));
                    });
                }).catch((error) => {
                    console.warn("Societies Fetch Error: "+error)
                });
            },
            fetchZones(){
                zonesREF.get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        // doc.data() is never undefined for query doc snapshots
                        this.bcc_centerID.push(doc.id);
                        this.bcc_centerName.push(doc.data().name);
                    });
                }).catch((error) => {
                    console.warn("Zones Fetch Error: "+error)
                });
            },
            read_sig_url(){
                // eslint-disable-next-line no-undef
                let input_block = $('#signature').prop('files')[0];
                let sig_ext = input_block.name.split('.').pop();
                // eslint-disable-next-line no-undef
                if ($.inArray(sig_ext, ['gif','png','jpg','jpeg']) === -1){
                    this.display_alert("Oops!", "Wrong file format detected!", "warning");
                }else{
                    this.signature_url = input_block;
                    this.signature_ext = sig_ext;
                    let reader = new FileReader();
                    reader.onload = (e) => {
                        // eslint-disable-next-line no-undef
                        $('.sig-container').css('background-image', 'url('+e.target.result+')');
                        // eslint-disable-next-line no-undef
                        $('.inner-hint').text(" change signature");
                    };
                    reader.readAsDataURL(input_block);
                }


            },
            determineOrganization(dob){
                let now = this.this_year();
                let since = this.formatDate(dob);
                if(since){
                    let tmp_since_yr = since.getFullYear();
                    let tmp_curr = now - tmp_since_yr;
                    if(this.singleParishionerData.isMarriedInChurch){
                        if(this.singleParishionerData.sex === 'male'){
                            this.singleParishionerData.statutoryOrganization = "CMO";
                            return "CMO"
                        }else if(this.singleParishionerData.sex === 'female'){
                            this.singleParishionerData.statutoryOrganization = "CWO";
                            return "CWO"
                        }
                    }else{
                        if(tmp_curr <= 12){
                            this.singleParishionerData.statutoryOrganization = "MCA";
                            return "MCA"
                        }else{
                            this.singleParishionerData.statutoryOrganization = "CYON"
                        } return "CYON"
                    }
                }
                return ""
            },
            deleteMember(){
                let loader = this.showLoadingOverlay("delete");
                const profile_pic_ref = this.singleParishionerData.pictureRef;
                const signature_ref = this.singleParishionerData.signatureRef;
                if(profile_pic_ref.length > 0){
                    const parishionerImageRef = parishionerStorageREF.child(profile_pic_ref);
                    parishionerImageRef.delete().then(()=>{
                        if(signature_ref.length > 0){
                            const parishionerSigRef = parishionerStorageREF.child(signature_ref);
                            parishionerSigRef.delete().then(()=>{
                                let tmp_parishionerRef = parishioners.doc(this.singleParishionerID);
                                const deleteVal = rawFirestore.FieldValue.delete();
                                tmp_parishionerRef.update({
                                    BCC: deleteVal,
                                    baptismalName: deleteVal,
                                    dateCreated: deleteVal,
                                    dateOfBaptism: deleteVal,
                                    dateOfBirth: deleteVal,
                                    dateOfConfirmation: deleteVal,
                                    dateOfFirstCommunion: deleteVal,
                                    dateOfMarriage: deleteVal,
                                    dateUpdated: deleteVal,
                                    email: deleteVal,
                                    familyID: deleteVal,
                                    isBaptised: deleteVal,
                                    isCommunicant: deleteVal,
                                    isConfirmed: deleteVal,
                                    isMarriedInChurch: deleteVal,
                                    nameOfParishWedded: deleteVal,
                                    occupation: deleteVal,
                                    otherName: deleteVal,
                                    parishID: deleteVal,
                                    phone: deleteVal,
                                    picture: deleteVal,
                                    pictureRef:deleteVal,
                                    signature:deleteVal,
                                    signatureRef:deleteVal,
                                    residentialAddress: deleteVal,
                                    sex: deleteVal,
                                    society: deleteVal,
                                    statutoryOrganization: deleteVal,
                                    surname: deleteVal,
                                    yearOfJoiningChurch: deleteVal
                                }).then(()=>{
                                    tmp_parishionerRef.delete().then(()=>{
                                        let tmpFamilyRef = familiesRef.doc(this.parishionerData.familyID);
                                        tmpFamilyRef.update({
                                            members: rawFirestore.FieldValue.arrayRemove(this.singleParishionerID)
                                        }).then(()=>{
                                            loader.hide();
                                            setTimeout(() => {
                                                this.display_alert('success', 'member removed', 'success');
                                                setTimeout(()=>{
                                                    this.$router.go();
                                                },2500);
                                            }, 1000);
                                        })
                                    })
                                })
                            })
                        }
                    }).catch((error)=>{
                        loader.hide();
                        setTimeout(() => {
                            this.display_alert('error', error, 'error');
                        }, 1000);
                    })
                }

            },
            getSocietyIDFromName(name){
                for(let count=0; count < this.societiesName.length; count++) {
                    if (this.societiesName[count].toLowerCase() === name.toLowerCase()){
                        return this.societiesID[count]
                    }
                }
                return ""
            },
        },
        mounted(){
            let tmpID = sessionStorage.getItem('dashboardID');
            if(tmpID){
                parishioners.doc(tmpID).get().then((doc) => {
                    if(!doc.exists){
                        this.$router.replace({name:'Login'})
                    }else{
                        this.loadParishionerData();
                        this.fetchZones();
                        this.fetchSocieties();
                    }
                });
            }else{
                this.$router.replace({name:'Login'})
            }


        },
        components: {
            'v-select': vSelect
        }
    }
</script>

<style scoped>
    .main-body{
        min-height: 600px;
        background:rgb(250,250,250);
        padding-top:10px
    }

    @media screen and (min-width: 320px){
        .signup-container{
            border: 2px solid #000;
            padding:30px;
        }
        .signup-body-1{
            padding:30px 20px 30px 20px;
        }
        .signup-container .signup-head{
            border: 1px solid #000;
        }
        .pic-frame{
            width:100%;
            height:200px;
            border: 1px solid #439EF3;
            border-radius: 10px;
            background: no-repeat center center;
            background-size: cover;
        }
        .frame-overlay{
            height:100%;
            border-radius: 5px;
            transition: .5s;
            padding:70px 20px
        }
        .pic-frame:hover{
            cursor: pointer;
        }
        .pic-frame:hover .frame-overlay{
            opacity: 1;
        }
        .pic-frame input[type="file"]{
            visibility: hidden;
        }
        label{
            width:100%
        }
        .no-width{
            width:auto;
        }
        .signup-body-2 .gap{
            margin-bottom: 10px;
        }

        .input-mask{
            width:20px;
            height:20px;
            background-color: rgb(200,200,200);
            margin-right:10px;
            border-radius: 5px;
        }
        .input-mask:hover{
            cursor: pointer;
        }
        .input-mask.active{
            background-color: #E12993;
        }
        .input-mask > input{
            visibility: hidden;
            position: absolute;
            width:100%;
            height:100%;
            top:0;
            left:0
        }
        .signup-head .head-img img{
            width: 100px;
            height:100px;
        }
        .signup-head .head-text h1{
            font-size: 1.3rem;
        }
        .signup-head .head-text h4{
            font-size: .9rem;
        }
        .signup-body-1 .head-text h4{
            font-size: 1.2rem;
        }
        .signup-body-header h2{
            font-size: 1.5rem;
        }
        .signup-body-header h4{
            font-size: 1.2rem;
        }
        .sig-container{
            width:200px;
            height:100px;
            border:1px solid #439EF3;
            border-radius: 10px;
            position: relative;
            transition: all linear .3s;
            background-size: cover;
        }
        .sig-container #signature{
            visibility: hidden;
            position: absolute;
            top:0;
            left:0;
            width:100%;
            height:100%;
            z-index: 1;
        }
        .sig-container:hover, .sig-container > .hint-text:hover{
            cursor: pointer;
        }
        .sig-container:hover{
            background-color: rgba(0,0,0,.2)
        }
        .sig-container > .hint-text{
            /*color: rgb(50,50,50);*/
            text-align: center;
            padding:7%;
            padding-top:20%;
            text-transform: lowercase;
            font-size: .8rem;
        }
    }
    @media screen and (min-width: 1024px){
        .signup-head .head-text .head-img img{
            max-width: 100%;
            height:auto!important;
        }
        .signup-head .head-text h1{
            font-size: 2.5rem;
        }
        .signup-head .head-text h4, .signup-body-1 .head-text h4, .signup-body-header h4{
            font-size: 1.5rem;
        }
        .signup-body-header h2{
            font-size: 2rem;
        }
    }
</style>